import React from 'react'
import './blockSearch.css'
import BlogPostArticle from './BlogPostArticle'
import ddata from '../FakeData/index.json'
import UseFetch from '../UseFetch'
import mainData from '../FetchDataLinks'
import BlogPostArticleSkeleton from './BlogPostArticleSkeleton'
import SeoHelmet from '../SEOHelmet/SeoHelmet'

function BlockSearch({ match }) {
    let a = 0;

    if (match.path === '/hashtag/:cat') {
        const { blogs, loading } = UseFetch(`${mainData.searchByHashtag}${match.params.cat}`)
        return (
            <div className="w3l-homeblock2 py-5">
                <SeoHelmet pageName={match.params.cat.charAt(0).toUpperCase() + match.params.cat.slice(1)} />
                <div className="container pt-md-4 pb-md-5">
                    {/* block */}
                    <h1 className="category-title mb-3"> {match.params.cat.charAt(0).toUpperCase() + match.params.cat.slice(1)}</h1>
                    <p className="mb-md-5 mb-4 max-width">Cateogarised Blog Post from {ddata[0].name}. Showing Results for {match.params.cat.charAt(0).toUpperCase() + match.params.cat.slice(1)}</p>
                    <div className="row">
                        {!loading && blogs.map((blog) => {
                            return <BlogPostArticle key={blog.id} PostContent={blog.Content} slug={blog.slug} image={blog.Image} PostHead={blog.Headline} PostName={blog.Headline} authorName={ddata[0].authorName} date={blog.date} time={blog.Time} />
                        })}
                        {loading && Array(6).fill().map(() => {
                            a++;
                            return <BlogPostArticleSkeleton key={`BlogPostSkeleton${a}`} />
                        })}
                    </div>
                    {/* <ul className="site-pagination text-center mt-md-5 mt-4">
                    <li><span aria-current="page" className="page-numbers current">1</span></li>
                    <li><a className="page-numbers" href="#page2">2</a></li>
                    <li><a className="page-numbers" href="#page3">3</a></li>
                    <li><span className="page-numbers dots">…</span></li>
                    <li><a className="page-numbers" href="#page7">7</a></li>
                    <li><a className="next page-numbers" href="#next">Next »</a></li>
                </ul> */}
                </div>
            </div>

        )
    } else if (match.path === '/cateogary/:cat') {
        const { blogs, loading } = UseFetch(`${mainData.searchByCateogary}${match.params.cat}`)
        return (
            <div className="w3l-homeblock2 py-5">
                <SeoHelmet pageName={match.params.cat.charAt(0).toUpperCase() + match.params.cat.slice(1)} />
                <div className="container pt-md-4 pb-md-5">
                    {/* block */}
                    <h1 className="category-title mb-3"> {match.params.cat.charAt(0).toUpperCase() + match.params.cat.slice(1)}</h1>
                    <p className="mb-md-5 mb-4 max-width">Cateogarised Blog Post from {ddata[0].name}. Showing Results for {match.params.cat.charAt(0).toUpperCase() + match.params.cat.slice(1)}</p>
                    <div className="row">
                        {!loading && blogs.map((blog) => {
                            return <BlogPostArticle key={blog.id} PostContent={blog.Content} image={blog.Image} PostHead={blog.Headline} PostName={blog.Headline} authorName={ddata[0].authorName} date={blog.date} time={blog.Time} />
                        })}
                        {loading && Array(6).fill().map(() => {
                            return <BlogPostArticleSkeleton key={`BlogPostSkeleton${a}`} />
                        })}
                    </div>
                    {/* <ul className="site-pagination text-center mt-md-5 mt-4">
                    <li><span aria-current="page" className="page-numbers current">1</span></li>
                    <li><a className="page-numbers" href="#page2">2</a></li>
                    <li><a className="page-numbers" href="#page3">3</a></li>
                    <li><span className="page-numbers dots">…</span></li>
                    <li><a className="page-numbers" href="#page7">7</a></li>
                    <li><a className="next page-numbers" href="#next">Next »</a></li>
                </ul> */}
                </div>
            </div>

        )
    }

}

export default BlockSearch
